import React, { useState } from 'react';
import style from './HealthDetail.module.css';
import { useNavigate, useLocation } from 'react-router-dom';
import HeadSub from '../../../../../components/comm/HeadSub';
import SwitchBox from '../../../../../components/box/SwitchBox';
import CustomTimePicker from '../../../../../components/datepicker/CustomTimePicker';
import Modal from '../../../../../components/comm/Modal';

import axiosApi from '../../../../../api/daonAxios';

import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';

const HealthDetail = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const surveyItem = location.state?.surveyItem;

    const [open, setOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [alarmTime, setAlarmTime] = useState(() => {
        const field = surveyItem?.alrmSetupField;
        if (field && field.length >= 12) {
            const timeStr = field.slice(-4);
            return {
                hour: parseInt(timeStr.substring(0, 2), 10),
                minute: parseInt(timeStr.substring(2, 4), 10)
            };
        }
        return { hour: 9, minute: 0 };
    });
    const [toggle, setToggle] = useState(surveyItem?.alrmAt === "1");
    const [reSwichStatus, setReSwichStatus] = useState(surveyItem?.reAlrmAt === "1");

    const onDismiss = () => setOpen(false);

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        return `${dateStr.slice(2, 4)}.${dateStr.slice(4, 6)}.${dateStr.slice(6, 8)}`;
    };

    const formatTime = (hour, minute) => {
        const ampm = hour < 12 ? "오전" : "오후";
        const hr = hour % 12 === 0 ? 12 : hour % 12;
        const min = String(minute).padStart(2, "0");
        return `${ampm} ${hr}:${min}`;
    };

    // 알림 ON
    const turnOnAlarm = async (time) => {
        if (!surveyItem?.idx) return;

        const user = JSON.parse(sessionStorage.getItem("loginUser"));
        const jToken = localStorage.getItem("jToken");

        const hourStr = String(time.hour).padStart(2, '0');
        const minStr = String(time.minute).padStart(2, '0');

        const requestBody = {
            idx: surveyItem.idx,
            mainAlrmAt: "1",
            cnncHsptlCd: surveyItem.cnncHsptlCd,
            cnncPatntNo: surveyItem.cnncPatntNo,
            alrmSetupField: `${surveyItem.cntsBgnDe}${hourStr}${minStr}`,
            usrUid: user?.usrUid,
            usrInfoId: user?.usrInfoId,
            pushTitle: surveyItem.srveySj,
            hospital: surveyItem.insttNm,
            department: surveyItem.cnncDeptNm,
            cntsBgnDe: surveyItem.cntsBgnDe,
            cntsEndDe: surveyItem.cntsEndDe,
        };

        try {
            await axiosApi.post("/notifications/health-record/push/on", requestBody, {
                headers: { "Authorization": `Bearer ${jToken}` }
            });
            setToggle(true);
        } catch (err) {
            console.error("알림 ON 실패:", err);
        }
    };

    // 알림 OFF
    const turnOffAlarm = async () => {
        if (!surveyItem?.idx) return;

        const user = JSON.parse(sessionStorage.getItem("loginUser"));
        const jToken = localStorage.getItem("jToken");

        const requestBody = {
            idx: surveyItem.idx,
            mainAlrmAt: "0",
            reAlrmAt: "0",
            cnncHsptlCd: surveyItem.cnncHsptlCd,
            cnncPatntNo: surveyItem.cnncPatntNo,
            usrUid: user?.usrUid,
            usrInfoId: user?.usrInfoId,
        };

        try {
            await axiosApi.post("/notifications/health-record/push/off", requestBody, {
                headers: { "Authorization": `Bearer ${jToken}` }
            });
            setToggle(false);
            setReSwichStatus(false);
        } catch (err) {
            console.log("알림 OFF 실패:", err);
        }
    };

    const buildAlrmSetupField = () => {
        const hourStr = String(alarmTime.hour).padStart(2, '0');
        const minStr = String(alarmTime.minute).padStart(2, '0');
        return `${surveyItem.cntsBgnDe}${hourStr}${minStr}`;
    };

    // 다시 알림 토글
    const toggleRepeatAlarm = async (status) => {
        if (!surveyItem?.idx) return;

        const user = JSON.parse(sessionStorage.getItem("loginUser"));
        const jToken = localStorage.getItem("jToken");

        const requestBody = {
            idx: surveyItem.idx,
            mainAlrmAt: "1",
            pushTrsmId: surveyItem?.pushTrsmId,
            reAlrmAt: status ? "1" : "0",
            cnncHsptlCd: surveyItem.cnncHsptlCd,
            cnncPatntNo: surveyItem.cnncPatntNo,
            usrUid: user?.usrUid,
            usrInfoId: user?.usrInfoId,
            pushTitle: surveyItem.srveySj,
            hospital: surveyItem.insttNm,
            department: surveyItem.cnncDeptNm,

            alrmSetupField: buildAlrmSetupField(),
            cntsBgnDe: surveyItem.cntsBgnDe,
            cntsEndDe: surveyItem.cntsEndDe,

        };

        try {
            await axiosApi.post("/notifications/health-record/push/on", requestBody, {
                headers: { "Authorization": `Bearer ${jToken}` }
            });
            setReSwichStatus(status);
        } catch (err) {
            console.log("다시 알림 상태 업데이트 실패:", err);
        }
    };

    const handleToggle = () => {
        if (toggle) {
            setIsModalOpen(true);
        } else {
            turnOnAlarm(alarmTime);
        }
    };

    const confirmTurnOff = () => {
        turnOffAlarm();
        setIsModalOpen(false);
    };

    const handleTimeConfirm = async (time) => {
        if (toggle) {
            await turnOffAlarm();
        }
        setAlarmTime(time);
        await turnOnAlarm(time);
        onDismiss();
    };

    if (!surveyItem) {
        return (
            <>
                <HeadSub title="건강 기록 상세" />
                <div className="container" data-padding="none">
                    <p style={{ padding: '20px', textAlign: 'center' }}>
                        데이터가 없습니다.
                    </p>
                </div>
            </>
        );
    }

    return (
        <>
            <HeadSub title="건강 기록 상세" />

            <div className="container" data-padding="none">
                <div className={style["Health-detail-box"]}>
                    <div className={style["innerbox"]}>
                        <div className={style['health-title']}>
                            <span>{surveyItem.srveySj}</span>
                        </div>
                        <div className={style["alarm-box"]}>
                            {toggle ?
                                <strong onClick={() => setOpen(true)}>
                                    {formatTime(alarmTime.hour, alarmTime.minute)}
                                </strong> :
                                <strong className={style['no-alarm']}>알림 없음</strong>
                            }
                            <div data-swich-size="sm">
                                <SwitchBox toggles={toggle} status={handleToggle} />
                            </div>
                        </div>
                        <div className={style["infom-wrap"]}>
                            {toggle && (
                                <div className='animation-1'>
                                    <div className={style["infom-box"]}>
                                        <p className={style["tit"]}>다시 알림 설정</p>
                                       <SwitchBox
                                            size="small"
                                            toggles={reSwichStatus}
                                            status={() => toggleRepeatAlarm(!reSwichStatus)}
                                            />
                                    </div>
                                </div>
                            )}

                            <div className={style["infom-box"]}>
                                <p className={style["tit"]}>기록 정보</p>
                                <p>
                                    <span>{surveyItem.insttNm}</span>
                                    <span>{surveyItem.cnncDeptNm}</span>
                                </p>
                            </div>
                            <div className={style["infom-box"]}>
                                <p className={style["tit"]}>기록 기간</p>
                                <span>
                                    {formatDate(surveyItem.srveyBgnDe)}~{formatDate(surveyItem.srveyEndDe)}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={style["Health-infom-box"]}>
                    <div className={style["inner-wrap"]}>
                        <p>{surveyItem.srveyDc1}</p>
                    </div>
                </div>

                <BottomSheet
                    scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                    expandOnContentDrag={false} // 내용 드래그로 확장 방지
                    open={open}
                    onDismiss={onDismiss}
                    snapPoints={({ minHeight }) => minHeight}
                    blocking={true}
                >
                    <CustomTimePicker
                        onClose={onDismiss}
                        onConfirm={handleTimeConfirm}
                        titleTxt="알림 시간 선택"
                        initialTime={alarmTime}
                    />
                </BottomSheet>

                <Modal isOpen={isModalOpen} setIsOpen={setIsModalOpen}>
                    <div className='modal-box' data-type="a">
                        <div className='modal-top-box'>
                            <div className='title-box'>
                                <p>알림을 끄시겠어요?</p>
                            </div>
                        </div>
                        <div className="modal-bottom-box">
                            <div className='btn-layout'>
                                <button
                                    className="btn"
                                    data-btn-type="fill-gray"
                                    data-btn-size="md"
                                    onClick={() => setIsModalOpen(false)}
                                >
                                    <span>취소</span>
                                </button>
                                <button
                                    className="btn"
                                    data-btn-type="fill-main"
                                    data-btn-size="md"
                                    onClick={confirmTurnOff}
                                >
                                    <span>끄기</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        </>
    );
};

export default HealthDetail;